//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        // Filter changes
        $(".search-input").on("keyup", function(e){
            var keyword = $(this).val();
            if(keyword != "" && keyword.length >= 3)
            {
                // Passing * allows us to get results for three characters or less.
                getSearchData(keyword + " *", $(this));
            }
            else
            {
                var $predictiveSearchResults = $(this).closest("div.row").find(".predictive-search-results");
                $predictiveSearchResults.html();
                $predictiveSearchResults.hide();
            }
            
        });

        $("body").on("click", "li.result-item", function(){
            // Put the value of what was clicked on into the search.
            //$(this).closest("form").find(".search-input").val($(this).html());
            $(this).closest("div.row").find(".predictive-search-results").html();
        });

        $("body").on("click", function(){
            var $predictiveSearchResults = $(".predictive-search-results");
            $predictiveSearchResults.html();
            $predictiveSearchResults.hide();
        });
    }

    function getSearchData(term, $searchInput)
    {
        if(window.curry.searchFeed.length > 0)
        {
            $.ajax({
                url: window.curry.searchFeed,
                type: "GET",
                data: {
                    terms: term
                },
                success: function (response) {
                    var $predictiveSearchResults = $searchInput.closest("div.row").find(".predictive-search-results");
                    
                    if(response != ""){
                        
                        $predictiveSearchResults.html(response);
                        $predictiveSearchResults.show();
                    }
                    else{
                        $predictiveSearchResults.hide();
                    }
                },
                error: function (xhr) {
                    //Do Something to handle error
                    alert("An error has occurred. Please contact an andministrator.");
                }
            });
        }
    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/search.js